export const APP_ROUTES = {
  MAIN: '/',
  PROJECTS: '/projects/',
  FORGOT_PASSWORD: '/forgot-password/',
  FORGOT_PASSWORD_SUCCESS: '/forgot-password-success/',
  PROFILE: '/profile/',
  PEOPLE: '/people',
  PREFERENCES: '/preferences/',
  PREFERENCES_USERS: '/preferences/users/',
  PREFERENCES_ROLES: '/preferences/roles/',
  PREFERENCES_INVITE_USER: '/preferences/users/invite-user',
  PREFERENCES_SUBSCRIPTION: '/preferences/subscription/',
  TASKS: '/tasks/',
  MESSENGER: '/messenger/',
  MY_ACTIVITY: '/activity/me/',
  CRM: '/crm/',
  CHANGELOG: '/changelog',
};
